import { render } from "./LeagueRecapView.vue?vue&type=template&id=360c27dc&scoped=true"
const script = {}

import "./LeagueRecapView.vue?vue&type=style&index=0&id=360c27dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360c27dc"]])

export default __exports__